__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/260d2db9c09231343a8887147c2f15d5206a77eacbd1d600e796be6f/";